import { getDays } from "@api";
import {getAxios} from "@api";

export default {
    state: {
        drawer: {
            isReady: false,
            isLoading: false,
            isExpanded: false,
            isExpandedMax: false,
            expansionHeight: '500px',
            dataHasChanged: false,
            dataIsSaving: false,
            loadingStates: {
                hotels: false,
                ferries: false,
                others: false,
                airlines: false,
                trains: false
            },
            lastUpdatedItem: null,
        },

    },
    mutations: {

        updateDrawer: function (state, value) {
            state.drawer = {...state.drawer, ...value}
        },

        updateDrawerLoading: function (state, newState) {
            state.drawer.isLoading = newState;
        },

        updatePlaceholderLoading: function (state, { type, isLoading }) {
            state.drawer.loadingStates[type] = isLoading;
        },

        updateQuickPlaceholders: function (state, { dayID, placeholderType, placeholderID, placeholderData }) {
            const dayIndex         = state.order.days.findIndex(x => x.id === dayID);
            const placeholderIndex = state.order.days[dayIndex][placeholderType].findIndex(x => x.id === placeholderID);
            state.order.days[dayIndex][placeholderType].splice(placeholderIndex, 1, placeholderData);
        },
    },
    actions: {
        fetchDrawerData: async function({state, dispatch, rootState}, { orderID }) {
            state.drawer.isReady = true;
            this.commit('updateDrawerLoading', true);
            const params = {
                _groups: ['trip_dashboard_read', 'modal_read', 'money_read', 'quick_edit'],
                'day.order.id': orderID,
            }

            if(!rootState.order.days || rootState.order.days.length === 0 || typeof rootState.order.days[0] === 'string') {
                await getAxios('days', {
                    'order.id': orderID,
                    '_groups': ['order_day_list_read'],
                }).then(response => {
                    this.commit('updateOrder', { days: response.data });
                }).catch(err => console.error('Error fetching days:', err));
            }



            try {
                await Promise.all([
                    dispatch('fetchHotelPlaceholders', params),
                    dispatch('fetchFerryPlaceholders', params),
                    dispatch('fetchOtherPlaceholders', params),
                    dispatch('fetchAirlinePlaceholders', params),
                    dispatch('fetchTrainPlaceholders', params),
                    dispatch('fetchFreeTexts', params),
                    dispatch('fetchRouteDetails', params)
                ]);
            } catch (error) {
                console.error('Error fetching placeholder data:', error);
            } finally {
                this.commit('updateDrawerLoading', false);
            }
        },

        fetchHotelPlaceholders: async function({commit, dispatch, rootState}, params) {
            try {
                commit('updatePlaceholderLoading', { type: 'hotels', isLoading: true });
                const response = await getAxios('hotel_placeholders', params);
                commit('updateOrder', { days: rootState.order.days.map(day => ({...day, hotelPlaceholders: response.data.filter(x => x.day.id === day.id)})) });

            } catch (error) {
                console.error('Error fetching hotels:', error);
            } finally {
                commit('updatePlaceholderLoading', { type: 'hotels', isLoading: false });
            }
        },

        fetchFreeTexts: async function({commit, dispatch, rootState}, params) {
            try {
                commit('updatePlaceholderLoading', { type: 'frees', isLoading: true });
                const response = await getAxios('free_text_items', params);
                commit('updateOrder', { days: rootState.order.days.map(day => ({...day, freeTextItems: response.data.filter(x => x.day.id === day.id)})) });

            } catch (error) {
                console.error('Error fetching freeTextItems:', error);
            } finally {
                commit('updatePlaceholderLoading', { type: 'frees', isLoading: false });
            }
        },

        fetchRouteDetails: async function({commit, dispatch, rootState}, params) {
            try {
                commit('updatePlaceholderLoading', { type: 'routes', isLoading: true });
                const response = await getAxios('route_details', params);
                commit('updateOrder', { days: rootState.order.days.map(day => ({...day, routeDetails: response.data.filter(x => x.day.id === day.id)})) });

            } catch (error) {
                console.error('Error fetching routes:', error);
            } finally {
                commit('updatePlaceholderLoading', { type: 'routes', isLoading: false });
            }
        },

        fetchFerryPlaceholders: async function({commit, rootState}, params) {
            try {
                commit('updatePlaceholderLoading', { type: 'ferries', isLoading: true });
                const response = await getAxios('ferry_placeholders', params);
                commit('updateOrder', { days: rootState.order.days.map(day => ({...day, ferryPlaceholders: response.data.filter(x => x.day.id === day.id)})) });
            } catch (error) {
                console.error('Error fetching ferries:', error);
            } finally {
                commit('updatePlaceholderLoading', { type: 'ferries', isLoading: false });
            }
        },

        fetchOtherPlaceholders: async function({commit, rootState}, params) {
            try {
                commit('updatePlaceholderLoading', { type: 'others', isLoading: true });
                const response = await getAxios('other_placeholders', params);
                commit('updateOrder', { days: rootState.order.days.map(day => ({...day, otherPlaceholders: response.data.filter(x => x.day.id === day.id)})) });
            } catch (error) {
                console.error('Error fetching others:', error);
            } finally {
                commit('updatePlaceholderLoading', { type: 'others', isLoading: false });
            }
        },

        fetchAirlinePlaceholders: async function({commit, rootState}, params) {
            try {
                commit('updatePlaceholderLoading', { type: 'airlines', isLoading: true });
                const response = await getAxios('airline_placeholders', params);
                commit('updateOrder', { days: rootState.order.days.map(day => ({...day, airlinePlaceholders: response.data.filter(x => x.day.id === day.id)})) });
            } catch (error) {
                console.error('Error fetching airlines:', error);
            } finally {
                commit('updatePlaceholderLoading', { type: 'airlines', isLoading: false });
            }
        },

        fetchTrainPlaceholders: async function({commit, rootState}, params) {
            try {
                commit('updatePlaceholderLoading', { type: 'trains', isLoading: true });
                const response = await getAxios('train_placeholders', params);
                commit('updateOrder', { days: rootState.order.days.map(day => ({...day, trainPlaceholders: response.data.filter(x => x.day.id === day.id)})) });
            } catch (error) {
                console.error('Error fetching trains:', error);
            } finally {
                commit('updatePlaceholderLoading', { type: 'trains', isLoading: false });
            }
        },
    },
    getters: {
        hotels: function(state, _, rootState) {
            const requests = []
            if(rootState.order && rootState.order.days) {
                rootState.order.days.forEach((day) => {
                    if(day.hotelPlaceholders) {
                        day.hotelPlaceholders.forEach((hotelPlaceholder) => {
                            if(hotelPlaceholder.requests) {
                                hotelPlaceholder.requests.forEach((request) => requests.push(request))
                            }
                        })
                    }
                })
            }
            return requests
        },
        others: function(state, _, rootState) {
            const requests = []
            if(rootState.order && rootState.order.days) {
                rootState.order.days.forEach((day) => {
                    if(day.otherPlaceholders) {
                        day.otherPlaceholders.forEach((otherPlaceholder) => {
                            if(otherPlaceholder.requests) {
                                otherPlaceholder.requests.forEach((request) => requests.push(request))
                            }
                        })
                    }
                })
            }
            return requests
        },
        ferries: function(state, _, rootState) {
            const requests = []
            if(rootState.order && rootState.order.days) {
                rootState.order.days.forEach((day) => {
                    if(day.ferryPlaceholders) {
                        day.ferryPlaceholders.forEach((ferryPlaceholder) => {
                            if(ferryPlaceholder.requests) {
                                ferryPlaceholder.requests.forEach((request) => requests.push({ ...request, contingent: { ...request.contingent, type: request.type }}))
                            }
                        })
                    }
                })
            }
            return requests;
        },
        nightFerries: function(state, getters) {
            return getters.ferries.filter(f => f.type === 'night');
        },
        dayFerries: function(state, getters) {
            return getters.ferries.filter(f => f.type === 'day');
        },
        airlines: function(state, _, rootState) {
            const requests = []
            if(rootState.order && rootState.order.days) {
                rootState.order.days.forEach((day) => {
                    if(day.airlinePlaceholders) {
                        day.airlinePlaceholders.forEach((airlinePlaceholder) => {
                            if(airlinePlaceholder.requests) {
                                airlinePlaceholder.requests.forEach((request) => requests.push({...request, placeholderInfo: {startAirport: request.startAirport, endAirport: request.endAirport}}))
                            }
                        })
                    }
                })
            }
            return requests
        },
        trains: function(state, _, rootState) {
            const requests = []
            if(rootState.order && rootState.order.days) {
                rootState.order.days.forEach((day) => {
                    if(day.trainPlaceholders) {
                        day.trainPlaceholders.forEach((trainPlaceholder) => {
                            if(trainPlaceholder.requests) {
                                trainPlaceholder.requests.forEach((request) => requests.push(request))
                            }
                        })
                    }
                })
            }
            return requests
        },
        dayTrains: function(state, getters) {
            return getters.trains.filter(f => f.type === 'day');
        },
        nightTrains: function(state, getters) {
            return getters.trains.filter(f => f.type === 'night');
        },

        drawer: function (state) {
            return state.drawer;
        },

        isHotelsLoading: function (state) {
            return state.drawer.loadingStates.hotels;
        },

        isFerriesToLoading: function (state) {
            return state.drawer.loadingStates.ferries;
        },

        isOthersLoading: function (state) {
            return state.drawer.loadingStates.others;
        },

        isAirlinesLoading: function (state) {
            return state.drawer.loadingStates.airlines;
        },

        isTrainsLoading: function (state) {
            return state.drawer.loadingStates.trains;
        }
    }
}
